import { Component, HostListener } from '@angular/core';
import { keyEnum } from './models/Constants';
import { RootScopeService } from './services/root-scope.service';
import * as Constants from './models/Constants';
import { LogService } from 'src/app/services/log.service';
import { Global } from './global/globalApi';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { environment } from 'src/environments/environment';
import { Title } from '@angular/platform-browser';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  displayAlert: boolean = false;
  className = "AppComponent";
  constructor(
    public rootScope: RootScopeService,
    private logger: LogService,
    private apiService: HttpClient,
    public genesysCloudService: GenesysCloudService,
    private titleService: Title,
  ) {
    this.identifyEnv();
    this.changeEnvTitle();
  }




  /****
   * Below code changes are related to CCR3-225:
   * 73 = I / ctrl+shift +I
   * 74 = J / ctrl+hift + J
   * 69 = e /alt + e
   * 70 = f /alt + f
   * 123 = f12
   * 83 = ctrl +s
   * 85 = ctrl + U
   * 80 = ctrl + P
   */

  // Mapping angular application with spring boot api here
  /* istanbul ignore next */
  identifyEnv() {

    let urlPath = window.location.href;
    console.log('urlpath' + urlPath);
    // DEV LifeCycle Config
    if (urlPath.includes(Constants.DEV_ENV)) {
      Global.domainUrl = Constants.DEV_ENV_APIURL;
      this.genesysCloudService.alisLogin = Constants.DEV_ENV;
      console.log('setApi' + Global.domainUrl);
    } else if (urlPath.includes(Constants.QA_ENV)) {// QA LifeCycle Config
      Global.domainUrl = Constants.QA_ENV_APIURL;
      this.genesysCloudService.alisLogin = Constants.QA_ENV;
      console.log('setApi' + Global.domainUrl);
    }
    else if (urlPath.includes(Constants.QC_ENV)) {// QC LifeCycle Config
      Global.domainUrl = Constants.QC_ENV_APIURL;
      this.genesysCloudService.alisLogin = Constants.QC_ENV;
      console.log('setApi' + Global.domainUrl);
    }
    else if (urlPath.includes(Constants.STAGE_ENV)) {// STAGE LifeCycle Config
      Global.domainUrl = Constants.STAGE_ENV_APIURL;
      this.genesysCloudService.alisLogin = Constants.STAGE_ENV;
      console.log('setApi' + Global.domainUrl);
    }
    else if (urlPath.includes(Constants.PROD_ENV)) {// QC LifeCycle Config
      Global.domainUrl = Constants.PROD_ENV_APIURL;
      this.rootScope.Prod_lifeCycle = true;
      this.genesysCloudService.alisLogin = Constants.PROD_ENV;
      console.log('setApi' + Global.domainUrl);
    }
    else if (urlPath.includes(Constants.LOCAL_ANGULAR_APIURL)) {
      Global.domainUrl = Constants.DEV_ENV_APIURL;
      this.genesysCloudService.alisLogin = Constants.LOCAL_ANGULAR_APIURL;
      console.log('setApi' + Global.domainUrl);
    }

    if (urlPath.includes('#error=access_denied')) {
      this.rootScope.ALISRegistrationCardError = true;
      sessionStorage.removeItem('ALISRegisteredRegionObj');
    } else { this.rootScope.ALISRegistrationCardError = false; }
  }
  /* To get build details of backend application running */
  
  /* istanbul ignore next */
  @HostListener('window:keydown', ['$event'])
  browserShortCut(event) {

    let msg = 'Shortcut keys cannot be used in Care Portal.';
    if (event.keyCode == 27) {
      //means user has pressed escaped button
      if (this.rootScope.loadUI == false) {
        // window.open('http://www.google.com', '_self');
      }
      return false;
    }
    if (event?.ctrlKey) {
      if (
        event?.shiftKey &&
        (event?.keyCode == keyEnum.I || event?.keyCode == keyEnum.J || event?.keyCode == keyEnum.W || event?.keyCode == keyEnum.R )
      ) {
        this.rootScope.enableAlerts(Constants.WARNING, msg);
        event.preventDefault();
        return false;
      }
      if (
        event.keyCode == keyEnum.P ||
        event.keyCode == 78 ||
        event.keyCode == 44 ||
        event.keyCode == keyEnum.S ||
        event.keyCode == keyEnum.U ||
        event.keyCode == keyEnum.R ||
        event.keyCode == keyEnum.F4 ||
        event.keyCode == keyEnum.W ||
        event.keyCode == keyEnum.F5
        
      ) {
        this.rootScope.enableAlerts(Constants.WARNING, msg);
        event.preventDefault();
        return false;
      }
    } else if (
      event?.altKey &&
      (event?.keyCode == keyEnum.E || event?.keyCode == keyEnum.F || event?.keyCode == keyEnum.ArrowLeft || event?.keyCode == keyEnum.ArrowRight || event?.keyCode == keyEnum.F4)
    ) {
      this.rootScope.enableAlerts(Constants.WARNING, msg);
      event.preventDefault();
      return false;
    } else if (event?.keyCode == keyEnum.F12 || event?.keyCode == keyEnum.F5) {
      //F12
      this.rootScope.enableAlerts(Constants.WARNING, msg);
      event.preventDefault();
      return false;
    }
    return true;
  }
  /*
Below code is related with CCR1-5691
Below code will change the title based on the env pipeline.
*/
/* istanbul ignore next */
  changeEnvTitle() {
    let url_address = window.location.href;

    if (url_address.includes(Constants.PROD_ENV)) {
      this.titleService.setTitle(Constants.ENV_PROD);       //PROD title
      this.rootScope.isCarePortalProd = true;
    }
    else if (url_address.includes(Constants.STAGE_ENV)) {
      this.titleService.setTitle(Constants.ENV_STAGE);        //stag title
      this.rootScope.isCarePortalProd = false;
    }
    else if (url_address.includes(Constants.DEV_ENV)) {
      this.titleService.setTitle(Constants.ENV_DEV);        //Dev title
      this.rootScope.isCarePortalProd = false;
    }
    else if (url_address.includes(Constants.QA_ENV)) {
      this.titleService.setTitle(Constants.ENV_QA);         //QA title
      this.rootScope.isCarePortalProd = false;
    }
    else if (url_address.includes(Constants.QC_ENV)) {
      this.titleService.setTitle(Constants.ENV_QC);         //QC title
      this.rootScope.isCarePortalProd = false;
    }
    else {
      this.titleService.setTitle(Constants.ENV_LOC);        //Local title
      this.rootScope.isCarePortalProd = false;
    }
  }
}
